import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Bell, Filter, RefreshCw } from "lucide-react";

export const NOTIF_KINDS = [
  { key: "all", label: "All" },
  { key: "signup", label: "Sign-ups" },
  { key: "application", label: "Applications" },
  { key: "esign", label: "Signatures" },
  { key: "upload", label: "Uploads" },
  { key: "contact", label: "Contact" },
  { key: "message", label: "Messages" },
  { key: "payment", label: "Payments" },
  { key: "listing", label: "Listings" },
  { key: "referral", label: "Referrals" },
];

export default function NotificationsTab({
  notifications, counts, filter, setFilter,
  autoRefresh, setAutoRefresh, lastRefreshed,
  onRefresh, onMarkAllRead,
}) {
  return (
    <>
      <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 flex-wrap" data-testid="admin-notif-filter-bar">
          <Filter className="h-4 w-4 text-[color:var(--text-secondary)]" />
          {NOTIF_KINDS.map((k) => {
            const count = counts[k.key] ?? 0;
            const active = filter === k.key;
            return (
              <button
                key={k.key}
                onClick={() => setFilter(k.key)}
                className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${active ? "bg-[color:var(--fire-red)] text-white border-[color:var(--fire-red)]" : "bg-white border-black/10 hover:border-[color:var(--fire-red)]"}`}
                data-testid={`admin-notif-filter-${k.key}`}
              >
                {k.label} <span className="opacity-70">({count})</span>
              </button>
            );
          })}
        </div>
        <div className="flex items-center gap-2">
          <label className="text-xs text-[color:var(--text-secondary)] flex items-center gap-1.5" data-testid="admin-auto-refresh-toggle">
            <input type="checkbox" checked={autoRefresh} onChange={(e) => setAutoRefresh(e.target.checked)} />
            Auto-refresh
          </label>
          <Button onClick={onRefresh} size="sm" variant="outline" className="border-black/10" data-testid="admin-refresh-now">
            <RefreshCw className="h-3.5 w-3.5 mr-1" />Refresh
          </Button>
          <Button onClick={onMarkAllRead} variant="outline" className="border-black/10" data-testid="admin-mark-all-read">Mark all read</Button>
        </div>
      </div>
      {lastRefreshed && (
        <p className="text-[10px] text-[color:var(--text-secondary)] mt-2" data-testid="admin-last-refreshed">
          Last refreshed {lastRefreshed.toLocaleTimeString()}
        </p>
      )}
      <div className="mt-3 space-y-2">
        {notifications.map((n) => (
          <Card key={n.notification_id} className={`border-black/5 ${!n.read ? "border-l-4 border-l-[color:var(--fire-red)]" : ""}`} data-testid={`admin-notif-${n.notification_id}`}>
            <CardContent className="p-4">
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div className="flex items-center gap-2">
                  <Bell className={`h-4 w-4 ${!n.read ? "text-[color:var(--fire-red)]" : "text-[color:var(--orange)]"}`} />
                  <Badge variant="outline" className="border-black/10 text-xs capitalize">{n.kind}</Badge>
                  <strong>{n.title}</strong>
                  {!n.read && <Badge className="bg-[color:var(--fire-red)] text-white text-[10px]">NEW</Badge>}
                </div>
                <span className="text-xs text-[color:var(--text-secondary)]">{new Date(n.created_at).toLocaleString()}</span>
              </div>
              <p className="mt-2 text-sm text-[color:var(--text-secondary)]">{n.body}</p>
            </CardContent>
          </Card>
        ))}
        {notifications.length === 0 && (
          <p className="text-sm text-[color:var(--text-secondary)]">All clear in this category.</p>
        )}
      </div>
    </>
  );
}
